const sectionCardBasicB1Css = `
[data-type='section-card-basic-b1'] .wrapper-container {
  color: var(--text-color, #ffffff);
}

[data-type='section-card-basic-b1'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-card-basic-b1'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-card-basic-b1'] .wrapper-content {
  max-width: 1040px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
  justify-content: center;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group {
  width: calc(55% - 30px);
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group[data-show-left-group='false'] {
  display: none;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group[data-order='1'] {
  order: 1;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group[data-order='2'] {
  order: 2;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content {
  display: none;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content[data-show-text='true'] {
  display: block;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h1,
[data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h2,
[data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h3,
[data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h4 {
  font-size: 24px;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group .wrap-icon-img {
  display: none;
  width: 100%;
  margin-bottom: 5px;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group .wrap-icon-img[data-show-icon='true'] {
  display: block;
}

[data-type='section-card-basic-b1'] .wrapper-content .left-group .wrap-icon-img img {
  display: inline-block !important;
  max-width: 100%;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group {
  width: calc(45%);
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group[data-show-right-group='false'] {
  display: none;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group[data-order='1'] {
  order: 1;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group[data-order='2'] {
  order: 2;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary {
  display: none;
  margin-bottom: 15px;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary[data-show-text='true'] {
  display: block;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h1,
[data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h2,
[data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h3,
[data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h4 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 10px 0 !important;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group .wrap-button [data-attribute='button-link'] {
  display: none;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group .wrap-button [data-attribute='button-link'][data-show-btn='true'] {
  display: block;
  text-align: center;
  padding: 16px 32px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: bold !important;
  margin-bottom: 10px;
}

[data-type='section-card-basic-b1'] .wrapper-content .right-group .wrap-button .sub-btn {
  font-size: 14px;
  text-align: center;
}

@container (max-width: 768px) {
  [data-type='section-card-basic-b1'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-card-basic-b1'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-card-basic-b1'] .wrapper-content {
    gap: 16px;
  }

  [data-type='section-card-basic-b1'] .wrapper-content .left-group {
    width: 100%;
  }

  [data-type='section-card-basic-b1'] .wrapper-content .right-group {
    width: 100%;
  }

  [data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h1,
  [data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h2,
  [data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h3,
  [data-type='section-card-basic-b1'] .wrapper-content .left-group .text-content h4,
  [data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h1,
  [data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h2,
  [data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h3,
  [data-type='section-card-basic-b1'] .wrapper-content .right-group .text-content-secondary h4 {
    font-size: 18px;
  }
}
`;
export default sectionCardBasicB1Css;
